import React, { createContext, useState, useContext } from "react";

const UserAccessContext = createContext();

export const useUserAccess = () => useContext(UserAccessContext);

export const UserAccessProvider = ({ children }) => {
  const [userAccess, setUserAccess] = useState("write");
  const [isShare, setIsShare] = useState(false);

  const setUserAccessType = (accessType, isShare) => {
    setUserAccess(accessType);
    setIsShare(isShare);
  };

  return (
    <UserAccessContext.Provider
      value={{ userAccess, setUserAccessType, isShare, setIsShare }}
    >
      {children}
    </UserAccessContext.Provider>
  );
};
